import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// Import all components
import { ProductListComponent } from '../components/product-list/product-list.component';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';

@Component({
  selector: 'lib-retail-billing',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ProductListComponent
  ],
  template: `
    <div class="retail-billing-container">
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="text-3xl font-medium text-900 mb-3">
          {{ 'RETAIL_BILLING.TITLE' | translate }}
        </div>
        <div class="text-500 mb-5">
          Manage your retail products, SKUs, categories, and brands
        </div>
        
        <!-- Main Product Management Component -->
        <lib-product-list>
        </lib-product-list>
      </div>
    </div>
  `,
  styles: [`
    .retail-billing-container {
      padding: 1rem;
    }
  `]
})
export class RetailBillingComponent implements OnInit {
  tenantId?: number;
  companyLevel: boolean = true;
  tenantInfo$: Observable<any>;

  constructor(private store: Store) {
    this.tenantInfo$ = this.store.select(TENANTS_INFO);
  }

  ngOnInit(): void {
    this.tenantInfo$.subscribe((tenantInfo) => {
      if (tenantInfo?.selected_tenant) {
        this.tenantId = tenantInfo.selected_tenant.id;
        this.companyLevel = true; // Default to company level
      }
    });
  }
}